module.exports = __webpack_public_path__ + "12796661_s.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/12796661_s.jpg
// module id = 267
// module chunks = 0